import { InternalTokens, ValueOf } from './tokens';

export const generateFontToken = ({
  fontWeight,
  fontSize,
  lineHeight,
  fontFamily,
}: {
  fontWeight: string
  fontSize: ValueOf<InternalTokens>
  lineHeight: ValueOf<InternalTokens>
  fontFamily: string
}): string => `${fontWeight} ${fontSize}/${lineHeight} ${fontFamily}`;
